var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgNftRoyalDraw(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#92C6EC",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.435 20.22C26.533 24.554 20.4 31 14.819 31a8.071 8.071 0 01-2.435-.513 3.163 3.163 0 01-.734-.352A3.469 3.469 0 0110 27.143v-.323c0-.124.036-.256.066-.403.031-.146.07-.29.117-.433 1.012-3.666 3.528-3.791 4.496-8.389a6.483 6.483 0 016.155-5.133 6.144 6.144 0 011.54.132l.176.044c.22.011.44.046.653.102a6.499 6.499 0 014.232 7.48z",
    fill: "#FAB14B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.01 19.362c-.896 4.305-6.83 10.567-12.33 10.773A3.469 3.469 0 0110 27.143v-.323c0-.125.036-.257.066-.403.03-.147.07-.29.117-.433 1.012-3.667 3.528-3.791 4.496-8.39a6.482 6.482 0 016.154-5.133 6.49 6.49 0 013.176 6.901z",
    fill: "#FFD966"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.427 12.572c.485-2.64 3.521-5.405 9.294-1.966 0 0-2.846 3.044-6.52 2.809a9.3 9.3 0 01-2.715-.36c-.11-.058-.073-.388-.059-.483z",
    fill: "#70CC70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.344 12.264c-3.594 2.236 6.727 5.983 7.057 9.276A10.91 10.91 0 0031 16.334c0-2.736-4.394-6.718-8.656-4.07z",
    fill: "#7EE67E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.935 17.562c.681-1.202.65-2.506-.069-2.913-.719-.408-1.854.236-2.535 1.438-.68 1.201-.65 2.505.069 2.913.719.407 1.854-.237 2.535-1.438z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 9)",
    d: "M0 0h21v22H0z"
  })))));
}
export default SvgNftRoyalDraw;